/* globals Routes */

import Routes from '../routes.js.erb';

Routes.configure({
  default_url_options: {
    locale: window.document.documentElement.lang,
  },
  url_links: true
});

// TODO 20210304 - refactoring needed: instead of using window.routes, we should use a helper.
window.Routes = Routes;
